import { isDefined, I18nService } from "@perxis-auto/shared";
import { APP } from "../../config/app.js";
import "../../config/env.js";
import "../../config/events.js";
function formatPrice(price, prefix, postfix) {
  if (!isDefined(price)) {
    return "";
  }
  const { i18n } = I18nService.getInstance();
  const preparedPrefix = prefix ? `${prefix} ` : "";
  const preparedPostfix = postfix ? ` ${postfix}` : "";
  let translatedCurrency;
  if (typeof price === "string") {
    const match = price.match(/^(\d+)(.*)$/);
    if (match) {
      const numberPart = parseInt(match[1], 10);
      const textPart = match[2] || "";
      translatedCurrency = `${i18n.t("format.currency", { value: numberPart, ns: APP.name })}${textPart}`;
    } else {
      translatedCurrency = price;
    }
  } else {
    translatedCurrency = i18n.t("format.currency", { value: price, ns: APP.name });
  }
  return `${preparedPrefix}${translatedCurrency}${preparedPostfix}`;
}
export {
  formatPrice
};
